export function transformLLMResponse(llmResponse) {
  if (!llmResponse) return null;

  return {
    incident_category: llmResponse.incident_category,
    observed_activity: llmResponse.observed_activity,
    risk_assessment: llmResponse.risk_assessment,
    recommended_action: Array.isArray(llmResponse.recommended_action)
      ? llmResponse.recommended_action
      : llmResponse.recommended_action
        ? [llmResponse.recommended_action]
        : [],
    next_action: llmResponse.next_action || []
  };
}
